var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.query['tid']=='5f7a66d5-c206-11ed-a4cd-509a4c5b67cf')?_c('resultDetail_MakerSpace'):_vm._e(),(_vm.$route.query['tid']=='5e21b204-c206-11ed-a4cd-509a4c5b67cf')?_c('resultDetail_student'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }